import { AimsCommonPopupEditorData, AimsCommonTableHeader } from '@aims/common-components';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CacheItem, TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { AllLocations, AllSubLocations, InvInventoryItem } from 'src/models';

@Component({
  selector: 'app-inventory-move-popup',
  templateUrl: './inventory-move-popup.component.html',
  styleUrls: ['./inventory-move-popup.component.css']
})
export class InventoryMovePopupComponent implements OnInit {

  public formGroup: any;
  public itemToMove;
  private transferHttp: TransferHttpService;
  inventory: Observable<any>;

  // Site/Location/SubLocation
  sites;
  loc: Observable<Array<AllLocations>>;
  sl: Observable<Array<AllSubLocations>>;

  locations;
  sublocations;

  siteSubj: BehaviorSubject<number>;
  locationSubj: BehaviorSubject<number>;

  quantity: number;
  origQuantity: number;
  origBarcode: string;
  lookupItem: InvInventoryItem;

  itemLookupColumns: AimsCommonTableHeader[] = [
    { key: 'barcode', label: 'Barcode', type: 'number'},
    { key: 'description', label: 'Description', type: 'string'},
    { key: 'partNo', label: 'Part #', type: 'string'}
  ];

  constructor(contentData: AimsCommonPopupEditorData) {
    this.transferHttp = contentData.contentData.transferHttp;
    this.itemToMove = contentData.contentData.itemToMove;
    this.formGroup = contentData.formGroup;

    this.sites = contentData.contentData.sites;
    this.loc = contentData.contentData.locations;
    this.sl = contentData.contentData.sublocations;

    this.origBarcode = this.itemToMove.barcode;
    this.origQuantity = this.quantity = this.getInventoryQuantity(this.itemToMove);

    // reactive form controls
    this.formGroup.addControl('barcode', new FormControl({ value: this.origBarcode, disabled: true }));
    this.formGroup.addControl('newbarcode', new FormControl({ value: '', disabled: false }, Validators.required));
    this.formGroup.addControl('itemlookup', new FormControl({ value: '', disabled: true }, Validators.required));
    this.formGroup.addControl('description', new FormControl({ value: this.itemToMove.description, disabled: true }));
    this.formGroup.addControl('site', new FormControl(this.itemToMove.siteId));
    this.formGroup.addControl('location', new FormControl(this.itemToMove.locationId));
    this.formGroup.addControl('sublocation', new FormControl(this.itemToMove.subLocationId));
    this.formGroup.addControl('quantity', new FormControl(this.quantity, Validators.required));

    this.formGroup.addControl('target', new FormControl('new'));
  }

  ngOnInit(): void {
    this.siteSubj = new BehaviorSubject(this.itemToMove.siteId);
    this.locationSubj = new BehaviorSubject(this.itemToMove.locationId);

    this.locations = combineLatest([this.loc, this.siteSubj]).pipe(
      map(([locArr, siteId]) => locArr.filter(l => l.siteId == this.itemToMove.siteId))
    );
    this.sublocations = combineLatest([this.locationSubj, this.sl]).pipe(
      map(([locId, slArr]) => slArr.filter(sl => sl.locationId == locId))
    );

    this.inventory = this.transferHttp.get('inventory/GetInventoryItems');
  }

  ngOnDestroy() { }

  siteChange(change: MatSelectChange) {
    this.itemToMove.locationId = null;
    this.locationSubj.next(null);
    this.itemToMove.subLocationId = null;
    let siteId = change.value;
    this.siteSubj.next(siteId);
  }

  locationChange(change: MatSelectChange) {
    this.itemToMove.subLocationId = null;
    let locationId = change.value;
    this.locationSubj.next(locationId);
  }

  public getInventoryQuantity(inventoryItem: InvInventoryItem): number {
    const sum: number = inventoryItem.invInventoryItemReceived.filter(ir => ir.quantity > 0)
      .map(i => i.quantity)
      .reduce((sum, current) => sum + current, 0);
    return sum;
  }

  public handleItemLookupChange(event) {
    this.lookupItem = event;

    this.formGroup.patchValue({ 'site': this.lookupItem.siteId });
    this.formGroup.patchValue({ 'location': this.lookupItem.locationId });
    this.formGroup.patchValue({ 'sublocation': this.lookupItem.subLocationId });
  }

  public radioChange(event) {
    if (event.value == 'new') {
      this.formGroup.get('newbarcode').enable();
      this.formGroup.get('itemlookup').disable();
      this.formGroup.get('quantity').enable();
    }
    else if (event.value == 'keep') {
      this.formGroup.get('newbarcode').disable();
      this.formGroup.get('itemlookup').disable();
      this.formGroup.get('quantity').disable();
      this.formGroup.patchValue({ 'quantity': this.origQuantity });
    }
    else { // existing
      this.formGroup.get('newbarcode').disable();
      this.formGroup.get('itemlookup').enable();
      this.formGroup.get('quantity').enable();

      this.formGroup.get('site').disable();
      this.formGroup.get('location').disable();
      this.formGroup.get('sublocation').disable();
    }
  }

}
